{
  "FormEngineTextareaElement": {
    "title": "Textbereich"
  },
  "mask": {
    "FormEngineTextareaElement": {
      "groupTitle": "Textbereich",
      "showError": "Fehler anzeigen",
      "rows": "Reihen"
    }
  }
}